import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { pdfStyles } from '../styles/pdf-styles';

interface PDFInfoFieldProps {
  label: string;
  value: string | number | null | undefined;
  layout?: 'default' | 'row';
  style?: any;
}

/**
 * Reusable PDF info field component (label-value pair)
 */
export const PDFInfoField: React.FC<PDFInfoFieldProps> = ({
  label,
  value,
  layout = 'default',
  style,
}) => {
  const fieldStyle = layout === 'row' ? pdfStyles.infoFieldRow : pdfStyles.infoField;
  const displayValue = value !== null && value !== undefined ? String(value) : ' ';

  return (
    <View style={[fieldStyle, style]}>
      <Text>
        <Text style={pdfStyles.infoLabel}>{label} : </Text>
        <Text style={pdfStyles.infoValue}>{displayValue}</Text>
      </Text>
    </View>
  );
};
